module.exports = __webpack_public_path__ + "img/66.1493717b.png";